import {Platform, TextStyle, ViewStyle} from 'react-native';
import Styles from 'src/components/Styles';

//#region Header

export function getHeaderBackground(content: JSX.Element): JSX.Element {
  return content;
}

export function headerFontSize(): number {
  return Styles.Fonts.f14;
}

export function subHeaderFontSize(): number {
  return Styles.Fonts.f1;
}

export function headerContainerStyleDescriptor(): {
  safeArea: ViewStyle;
  container: ViewStyle;
  headerTextContainer: TextStyle;
  headerTextStyle: TextStyle;
  maxFontSizeMultiplier: number;
} {
  return {
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: Styles.tabBarBackgroundColor,
    },
    safeArea: {
      backgroundColor: Styles.darkBlueRevolveColor,
    },
    headerTextContainer: {
      height: 34,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerTextStyle: {
      fontSize: headerFontSize(),
      color: Styles.white,
      fontWeight: '400',
      textTransform: 'uppercase',
      fontFamily: Styles.FontFamily.comodoVintage,
      lineHeight: headerFontSize() + 4,
      marginTop: Platform.OS === 'ios' ? Styles.Spacing.m1 : Styles.Spacing.m0,
    },
    maxFontSizeMultiplier: Styles.FontSizeMultiplier.maxfm0,
  };
}

export function subHeaderContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    subHeaderTextStyle: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
    },
  };
}

export function getBackIconColor(_transparent: boolean): string {
  return '#A4DB57';
}

//#endregion

//#region Body

export function primaryColor(): string {
  return Styles.Colors.PayNew.primary01;
}

export function primaryColorButton(): string {
  return Styles.Colors.PayNew.primary01;
}

export function bodyLargeFontSize(): number {
  return Styles.Fonts.f1;
}

export function bodyFontSize(): number {
  return Styles.Fonts.f1;
}

export function bodySmallFontSize(): number {
  return Styles.Fonts.f8;
}

export function bodyTinyFontSize(): number {
  return Styles.Fonts.f0;
}

export function shadowStyles(): {
  shadow: ViewStyle;
  lightShadow: ViewStyle;
} {
  const backgroundColor = '#FFFFFF';
  const borderColor = '#CFCFCF';
  const shadow =
    Platform.OS === 'ios'
      ? {
          shadowColor: 'rgba(0, 0, 0, 0.02)',
          shadowOffset: {width: 0, height: 2},
          shadowOpacity: 1,
          shadowRadius: 2,
          borderWidth: 1,
          borderColor,
          backgroundColor,
        }
      : {
          elevation: 1,
          borderWidth: 1,
          borderColor,
          backgroundColor,
        };
  return {
    shadow,
    lightShadow: shadow,
  };
}

//#endregion

//#region Footer

export function bottomTabBtnColor(): string {
  return Styles.blueRevolve;
}

export function getFooterNameTextDesc(isFocused): {
  [key: string]: {[key: string]: number | string};
} {
  return {
    footerNameText: {
      fontFamily: mainFontFamily(),
      fontSize: 10,
      fontWeight: isFocused ? '700' : '400',
      textAlign: 'center',
    },
  };
}

//#endregion

export function mainFontFamily(): string {
  return Styles.FontFamily.figtreeRegular;
}

export default {
  getHeaderBackground,
  headerContainerStyleDescriptor,
  getBackIconColor,
  headerFontSize,
  subHeaderFontSize,
  bodyFontSize,
  bodyLargeFontSize,
  bodySmallFontSize,
  bodyTinyFontSize,
  subHeaderContainerStyleDescriptor,
  bottomTabBtnColor,
  getFooterNameTextDesc,
  shadowStyles,
  mainFontFamily,
  primaryColor,
  primaryColorButton,
};
